"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveArrayValues = void 0;

var resolveArrayValues = function resolveArrayValues(value) {
  var _value$split;

  return value === null || value === void 0 ? void 0 : (_value$split = value.split(',')) === null || _value$split === void 0 ? void 0 : _value$split.map(function (elementValue) {
    return elementValue.trim();
  });
};

exports.resolveArrayValues = resolveArrayValues;